import { getUserInfo } from "@api/user";
import { getProjectInfo } from "@api/eval";
import cookie from "vue-cookies"

const LOGIN_KEY = "login_status";

const state = {
  homeActive: false,
  token: cookie.get(LOGIN_KEY) || null,
  userInfo: null,
  project: null
};

const mutations = {
  LOGIN(state, {token, expire}) {
    state.token = token;
    cookie.set(LOGIN_KEY, token, new Date(expire));
  },
  LOGOUT(state) {
    state.token = undefined;
    cookie.remove(LOGIN_KEY);
  },
  SET_PROJECT: (state, project) => {
    state.project = project;
  },
  UPDATE_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
  }
};

const actions = {
  USERINFO({ state, commit }, force) {
    if (state.userInfo !== null && !force){
      return Promise.resolve(state.userInfo);
    } else {
      return new Promise(reslove => {
        getUserInfo().then(res => {
          console.info(res);
          commit("UPDATE_USERINFO", res.result);
          reslove(res.result);
        });
      }).catch(() => {
        console.error("获取信息失败!");
      });
    }
  },
  getProject({ commit, state }, projectId) {
    getProjectInfo(projectId).then(res => {
      const data = res.data.result;
      if (data) {
        commit("SET_PROJECT", data);
        localStorage.setItem("project", JSON.stringify(data || {}));
      } else {
        console.log("获取项目失败！", res);
      }
    });
  }
};

export default {
  state,
  mutations,
  actions
};
